Platform.Deferred.execute(setCartCheckoutScript);

function setCartCheckoutScript() {
    root = $('body').data('root');

    LoadCheckoutCart();
}

function LoadCheckoutCart(callback) {
    var showDiscount = $('.pf-checkout-cart-loader').data('show-discount');
    var getCartUrl = root + 'cart/GetCart' + (showDiscount ? '?showDiscount=true' : '');
    $('.pf-checkout-cart-loader').load(getCartUrl, function () {
        if (callback)
            callback();
    });
}

// Register handlers for cart actions
$(document).on('itemUpdated.cart.platform', function (event, data) {
    LoadCheckoutCart(function () {
        $(".pf-checkout-cart-loader .checkout-cart-footer-row").highlight();  
    });
});

$(document).on('itemRemoved.cart.platform', function (event, data) {
    LoadCheckoutCart(function () {
        $(".pf-checkout-cart-loader .checkout-cart-footer-row").highlight();
    });
});

$(document).on('discountUpdated.cart.platform', function (event, data) {
    LoadCheckoutCart(function () {
        $(".pf-checkout-cart-loader .checkout-cart-footer-row").highlight();
    });
});